import styled from "styled-components";

export const FooterButtons = styled.div`
  flex: 1;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  margin-left: -20px;
  button:focus-within {
    outline: 1px dotted #212121;
    outline: 5px auto -webkit-focus-ring-color;
  }
`;